// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "(max-width: 1024px)";
var _4 = "(max-width: 768px)";
var _5 = "screen and (max-width: 600px)";
var _6 = "card-3f1HI";
var _7 = "card_minimum-2pTmu";
var _8 = "card_optimum-1oh28";
var _9 = "card_maximum-2X7fL";
var _a = "tag-2W_vr";
var _b = "icon-3BKDH";
var _c = "type-2SCKR";
var _d = "services-1mCcy";
var _e = "service-23jpd";
var _f = "price-3dUKI";
var _10 = "select-JGFic";
var _11 = "title-1bPOm";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "tablet", _4 as "tabletMiddle", _5 as "mobile", _6 as "card", _7 as "card_minimum", _8 as "card_optimum", _9 as "card_maximum", _a as "tag", _b as "icon", _c as "type", _d as "services", _e as "service", _f as "price", _10 as "select", _11 as "title" }
export default { "__esModule": _1, "tablet_only": _2, "tablet": _3, "tabletMiddle": _4, "mobile": _5, "card": _6, "card_minimum": _7, "card_optimum": _8, "card_maximum": _9, "tag": _a, "icon": _b, "type": _c, "services": _d, "service": _e, "price": _f, "select": _10, "title": _11 }
